<div [ngClass]="nativeSectionsService.getClassByLiteralId(dashboardId)">
  <span
    [ngClass]="[
      noDataValues.includes(data) ? 'no-data' : 'data',
      dataHovered ? (cellLayoutType | lowercase) : '',
    ]"
    >{{ data }}</span
  >
</div>
